import { AdminLogin, InstructorLogin, StudentLogin, StudentSignUp } from 'Api/auth.api';

/**
 * Auth Module
 */
import Vue from 'vue'
import router from '../../../router';

// require('./subscriber')
const state = {
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('token'),
    type: localStorage.getItem('type'),
}

// getters
const getters = {
    getToken: state => {
        return state.token;
    },
    getUser: state => {
        return state.user;
    },
    isLoggedIn: state => { 
        return !( !state.user || !state.token );
    },
    userType: state => {
        return state.type
    }
}

// actions
const actions = {
     signIn(context, credentials){
        let type = credentials.type;
        delete credentials.type;
        
        ( type == 'admin'  ?  AdminLogin( credentials ) : ( type == 'instructor'  ?  InstructorLogin( credentials ) : StudentLogin( credentials ) ) )
        .then(response => {
            if(response.status == 200 ){
                setTimeout(() => {
                    context.commit('SET_TOKEN', response.headers['x-auth-token']);
                    context.commit('SET_USER', response.data );
                    context.commit('SET_USER_TYPE', type );
                    context.commit('loginSuccess', response.data );
                    if( router.currentRoute.name == 'login' ){
                        // if( type == 'student' ){
                        //     router.push({name: 'Stu_Profile'})
                        // }
                        // if( type == 'instructor' ){
                        //     router.push({name: 'InsProfile'})
                        // }
                        router.push({name: 'Home'});
}                        }, 500)
                setTimeout(() => {
                    // context.dispatch('getStatuses');
                    // context.dispatch('fetchCategories');
                }, 1500);
                
            }else{
                context.commit('loginUserFailure', response.data.response);
            }
        })
        .catch(error => {
            console.log(error); 
        });
     },
     async fetchUser( context, response){
         return;
             context.commit('SET_TOKEN', response.headers['x-auth-token']);
         if( !context.state.token ){
             return;
         }
         setTimeout(() => {
            context.commit('SET_USER', response.data );
            context.commit('loginSuccess', response.data );
            console.log( router );
            if( router.currentRoute.name == 'login' ){
                router.push({name: 'home'});
            }
        }, 500);

        },
     async updateUserData(context){
        await fetchUser()
        .then(response => {
            if(response.status == 200 ){
                setTimeout(() => {
                    context.commit('SET_USER', response.data );
                    console.log( router );
                }, 500);
            }
        });
     },
    sendEmail(context){
        context.commit('sendEmailSuccessfully');
    },
    invalidEmail(context){
        context.commit('invalidEmailSent');
    },
    logoutUser(context, payload){
        context.commit('logoutUser');
    },
    signUp(context, credentials){
        
        StudentSignUp( credentials )
        .then(response => {
            if(response.status == 200 ){
                setTimeout(() => {
                    context.commit('SET_TOKEN', response.headers['x-auth-token']);
                    context.commit('SET_USER', response.data );
                    context.commit('SET_USER_TYPE', 'student' );
                    context.commit('loginSuccess', response.data );
                        router.push({name: 'Home'});
                        }, 500).bind(type);
            }else{
                context.commit('loginUserFailure', response.data.response);
            }
        })
        .catch(error => {
            console.log(error); 
        });
     },
}

// mutations
const mutations = {

    SET_TOKEN (state, token){
        state.token = token;
        localStorage.setItem('token', token);
    },
    SET_USER (state, user){
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
    },
    SET_USER_TYPE (state, type){
        state.type = type;
        localStorage.setItem('type', type);
    },
    loginSuccess(state, payload) {
        // router.push( "/clients" );
        // router.push("/default/dashboard/country");        
        setTimeout(function(){
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: 'Success!'
            });
       },1500);
    },
    loginUserFailure(state, error) {
        // Nprogress.done();
        // Vue.notify({
        //     group: 'loggedIn',
        //     type: 'error',
        //     text: error.message
        // });
    },
    logoutUser(state) {
        state.token = null;
        state.user = null;
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        router.push({name: 'login'});
    },
    signUpUser(state) {
        // Nprogress.start();
    },
    signUpUserSuccess(state, user) {
        state.user = localStorage.setItem('user', user);
        router.push("/default/dashboard/ecommerce");
        Vue.notify({
            group: 'loggedIn',
            type: 'success',
            text: 'Account Created!'
        });
    },
    signUpUserFailure(state, error) {
        // Nprogress.done();
        //  Vue.notify({
        //     group: 'loggedIn',
        //     type: 'error',
        //     text: error.message
        // });
    },
    sendEmailSuccessfully(state){
        router.push("/session/login");
         Vue.notify({
            group: 'loggedIn',
            type: 'success',
            text: 'Email Sent Successfully!'
        });
    },
     invalidEmailSent(state){
         Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: 'Please Enter Valid Email Id!'
        });
     }
}

export default {
    state,
    getters,
    actions,
    mutations
}
